import { useEffect, useState } from "react";
import { apiPost } from "../lib/api";

interface Props {
  open: boolean;
  onClose: () => void;
  gapId: string;
  recipientId: string;
  recipientFirstName: string;
  recipientPhone: string | null;
}

interface DraftBody {
  draft: { body: string; source?: string };
}

export default function TextDraftPanel({
  open,
  onClose,
  gapId,
  recipientId,
  recipientFirstName,
  recipientPhone,
}: Props) {
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState<string | null>(null);
  const [body, setBody] = useState("");
  const [copied, setCopied] = useState(false);

  useEffect(() => {
    if (!open) return;
    setLoading(true);
    setError(null);
    setCopied(false);
    apiPost<DraftBody>("/drafts/text", {
      gapId,
      recipient: "shortlist",
      recipientId,
      recipientFirstName,
    })
      .then((res) => setBody(res.draft.body))
      .catch((err: Error) => setError(err.message))
      .finally(() => setLoading(false));
  }, [open, gapId, recipientId, recipientFirstName]);

  if (!open) return null;

  return (
    <div className="draft-overlay" role="dialog" aria-modal="true" onClick={onClose}>
      <div className="draft-panel" onClick={(e) => e.stopPropagation()}>
        <div className="draft-panel__header">
          <h2 className="draft-panel__title">Text {recipientFirstName}</h2>
          <button type="button" className="btn btn--ghost" onClick={onClose}>
            Close
          </button>
        </div>

        {loading ? (
          <p className="placeholder">Drafting…</p>
        ) : error ? (
          <p className="placeholder">Couldn't draft: {error}</p>
        ) : (
          <>
            {recipientPhone ? (
              <div className="draft-panel__field">
                <label className="draft-panel__label">To</label>
                <div className="draft-panel__static">{recipientPhone}</div>
              </div>
            ) : null}
            <div className="draft-panel__field">
              <label className="draft-panel__label" htmlFor="text-body">
                Message
              </label>
              <textarea
                id="text-body"
                className="draft-panel__textarea"
                value={body}
                onChange={(e) => setBody(e.target.value)}
                rows={5}
              />
            </div>
            <div className="draft-panel__actions">
              <button
                type="button"
                className="btn"
                onClick={async () => {
                  await navigator.clipboard.writeText(body);
                  setCopied(true);
                }}
              >
                {copied ? "Copied ✓" : "Copy to clipboard"}
              </button>
              <button type="button" className="btn btn--ghost" onClick={onClose}>
                Done
              </button>
            </div>
          </>
        )}
      </div>
    </div>
  );
}
